import { Code } from "@mantine/core";

export const codeComponentSettings = Code.extend({
  defaultProps: {
    // color: "pink",
  },
});
